import React, { useState, useEffect } from 'react';
import Menu from '@mui/material/Menu';
import { useStateValue } from '../../../Contexto/store';
import DiccionarioEtiquetas from '../../../Configuracion/Idiomas/Etiquetas_Diccionario';
import { Button, CardMedia, Typography, Divider, Avatar, Box } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import withStyles from '@mui/styles/withStyles';
import { styleButtonBar } from '../../Tool/Style';
import RutasComponente from '../../../Configuracion/RutaComponentes';
import SetModulos from '../../../Configuracion/SetModulos/SetModulos';
import { useMsal } from "@azure/msal-react";
import { useIsAuthenticated } from "@azure/msal-react";
import { mostrarDialogoSubirImagen, DialogoSubirImagen } from '../../ControlUsuario/SubirImagen';
import { guardarImagenUsuario, registroCierreSesion } from '../../../Actions/Usuarios/UsuarioAction';
import { LlavesAuthConfig } from '../../../Configuracion/Llaves/RepositorioConfig';

import ExitToAppIcon from '@mui/icons-material/ExitToApp';

import { MostrarMensaje } from '../../../Utilidades/ManejoMensajes';

import { styleToolBar } from '../../Tool/Style';

const StyledMenu = withStyles({
    paper: {
        border: '1px solid #d3d4d5',
    },
})((props) => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
));

const PerfilUsuarioModal = () => {

    const styleBotonCerrar = {
        Button: {
            width: "auto",
            height: 36,
            backgroundColor: '#EDF0F4',
            color: '#4A606C',
            textTransform: 'none',
            marginTop: '8px'
        }
    };

    const IconoCamara = {
        Icon: {
            fontSize: 24,
            color: '#4A606C'
        }
    };

    //Estilo de los iconos de la barra
    const classIcon = styleButtonBar();

    //determina si el usuario esta autenticado por Azure Active Directory
    const autenticadoADD = useIsAuthenticated();

    // Representa la instalacia de validacion por medio SSO con Azure Active Directory
    const { instance } = useMsal();

    const [{ etiquetasIdioma, sesionUsuario, compania, autorizacion }, dispatch] = useStateValue();

    useEffect(() => {
        setAnchorEl(null);
    }, [sesionUsuario?.usuario]);

    const [anchorEl, setAnchorEl] = useState(null);

    const CerrarPerfilUser = () => {
        setAnchorEl(null);
    };

    const seleccionaCerrarSesion = async (event) => {
        event.preventDefault();

    };

    const ClickMenuPerfilUser = (event) => {
        setAnchorEl(event.currentTarget);

    };

    // Se declara la variable de estado que representa al idioma para las etiquetas del componente
    const [etiquetas, setEtiquetas] = useState({
        EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
        CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
    });

    useEffect(() => {
        // se llama al dispatch para que como tal se actualice el reducer
        setEtiquetas({
            EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
            CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
        });

    }, [etiquetasIdioma]);


    const generaAuditoriaLogout = async () => {
        await registroCierreSesion(sesionUsuario.usuario.userId, false).then(response => {
            if (response.status !== 200) {
                if (response.data.errors) {
                    const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
                    MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
                } else {
                    MostrarMensaje(dispatch, 'error', [response.statusText]);
                }
            }
        });
    };

    const LimpiaSesionUsuarioActual = () => {

        //let etiquetaidiomalocalStorage = "";
        //let rememberlocalStorage = false;
        //let userlocalStorage = "";

        generaAuditoriaLogout();

        //try {
        //    etiquetaidiomalocalStorage = localStorage.getItem('etiqueta_idioma');
        //    rememberlocalStorage = localStorage.getItem('remember');
        //    userlocalStorage = localStorage.getItem('User');
        //} catch (err) { }

        // Se limpiar localstorage
        //localStorage.clear();
        localStorage.removeItem('selected_company');
        localStorage.removeItem('token_seguridad');
        localStorage.removeItem('UtmItraSisCli');

        //if (etiquetaidiomalocalStorage !== null && etiquetaidiomalocalStorage !== undefined && etiquetaidiomalocalStorage !== "")
        //    localStorage.setItem('etiqueta_idioma', etiquetaidiomalocalStorage);

        //if (rememberlocalStorage !== null && rememberlocalStorage !== undefined && rememberlocalStorage !== false && rememberlocalStorage !== "false") {
        //    localStorage.setItem('remember', rememberlocalStorage);
        //    localStorage.setItem('User', userlocalStorage);
        //}

        // se incializa el reducer con la autorizacion del usurio al valor inicial del archivo de rutas donde todo esta denegado 
        dispatch({
            type: "AUTORIZACION",
            autorizacion: {
                Rutas: RutasComponente.Rutas,
                RutaLogin: RutasComponente.RutaLogin,
                RutaHome: RutasComponente.RutaHome,
                RutaNotFound: RutasComponente.RutaNotFound,
                RutaRecorevyPassword: RutasComponente.RutaRecorevyPassword,
                RutaRecorevyPasswordSussed: RutasComponente.RutaRecorevyPasswordSussed,
                RutaChangePassword: RutasComponente.RutaChangePassword,
                Modulo: autorizacion.Modulo
            }
        });

        // Se inicializa el reducer de modulos del usuario 
        dispatch({
            type: "MODULOS_AUTORIZACION",
            autorizacionMod: {
                Modulos: SetModulos.Modulos
            }
        });

        //se limpia la variable de sesion del storage
        dispatch({
            type: "SALIR_SESION",
            nuevousuario: null,
            autenticado: false,
            tipoLogueo: ''
        });
    };

    const ImageHeader = {
        ImageName: "",
        ContentType: "",
        ContentBase64: sesionUsuario.usuario.imagenPerfil
    };

    const [imagenToSave, setImagenToSave] = useState({
        ImageName: '',
        ContentType: '',
        ContentBase64: ''
    });

    function ChangeImagenToSave(nombre, tipo, contenido, extension) {
        setImagenToSave({
            ImageName: nombre,
            ContentType: tipo,
            ContentBase64: contenido,
            extension
        });
    }
    function salvarImagenUsuario() {

        if (imagenToSave.ImageName !== '' && imagenToSave.ContentType !== '' && imagenToSave.ContentBase64 !== '') {
            const objetoImagen = {
                UserIdRel: sesionUsuario.usuario.userId,
                ImageName: imagenToSave.ImageName,
                ContentType: imagenToSave.ContentType,
                ContentBase64: imagenToSave.ContentBase64,
                CompanyId: sesionUsuario.usuario.companyId,
                UserId: sesionUsuario.usuario.userId,
                extension: imagenToSave.extension,
            };

            guardarImagenUsuario(objetoImagen).then(response => {
                if (response.status === 200) //si la respuesta fue existosa 
                {
                    const usuario = {
                        userId: sesionUsuario.usuario.userId,
                        nombreCompleto: sesionUsuario.usuario.nombreCompleto,
                        email: sesionUsuario.usuario.email,
                        username: sesionUsuario.usuario.username,
                        imagenPerfil: imagenToSave.ContentBase64,
                        defaultLanguage: sesionUsuario.usuario.defaultLanguage,
                        companyId: sesionUsuario.usuario.companyId,
                        customerId: sesionUsuario.usuario.customerId
                    };

                    dispatch({
                        type: "INICIAR_SESION",
                        sesion: usuario,
                        autenticado: sesionUsuario.autenticado,
                        tipoLogueo: sesionUsuario.tipoLogueo
                    });

                    MostrarMensaje(dispatch, 'success', ["updateOk"]);

                    setAnchorEl(null);
                }
                else {
                    if (response.data.errors) {
                        const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
                        //revisado ok
                        MostrarMensaje(dispatch, response.data.typeError, arrayErrores);

                    } else {
                        MostrarMensaje(dispatch, 'error', [response.statusText]);
                    }
                }
            });
        }
    };

    //Funcion para el logout 
    const salirSesionUsuario = () => {
        // Limpieza de variable de localstorage del token 
        if (sesionUsuario.autenticado === true && sesionUsuario.tipoLogueo !== 'SSO') {
            LimpiaSesionUsuarioActual();
        }
        else if (sesionUsuario.autenticado === true && sesionUsuario.tipoLogueo === 'SSO' && autenticadoADD === true) {

            instance.logoutPopup({ postLogoutRedirectUri: LlavesAuthConfig.auth.redirectUri, mainWindowRedirectUri: LlavesAuthConfig.auth.redirectUri })
                .then(response => {
                    LimpiaSesionUsuarioActual();
                })
                .catch(e => {
                    console.log(e);
                });

        }
    };

    return (
        <React.Fragment>
            <DialogoSubirImagen imagenVer={ImageHeader} onClickGuardar={salvarImagenUsuario} onInputChange={ChangeImagenToSave} tituloModal={etiquetas.EtiquetasComponente.DialogoSubirImagen.Et_FotoPerfil} />
            <Button color="inherit" className={classIcon.Button} onClick={ClickMenuPerfilUser} aria-controls="ProfileUser-menu" aria-haspopup="true">
                <Avatar color='primary' src={sesionUsuario ? sesionUsuario.usuario.imagenPerfil : null} className={classIcon.Avatar}
                    style={{ color: compania.CfgNavIconColor, backgroundColor: compania.CfgNavIconBG }} ></Avatar>
                <KeyboardArrowDownIcon className={classIcon.Icon} style={{ color: compania.CfgNavIconColor }} />
            </Button>

            <StyledMenu
                id="ProfileUser-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={CerrarPerfilUser}
            >
                <Box display="flex" alignItems="center" justifyContent="center" width={230} sx={{ position: 'relative', marginBottom: '25px' }}>
                    <CardMedia
                        component='img'
                        alt=""
                        onClick={mostrarDialogoSubirImagen}
                        style={{
                            width: '140px', height: '140px', borderRadius: '50%', border: '3px solid rgb(231, 235, 239)',
                            marginTop: '5px', cursor: 'pointer'
                        }}
                        src={sesionUsuario ? sesionUsuario.usuario.imagenPerfil : null} />

                    <Box display="flex" alignItems="center" justifyContent="center" onClick={mostrarDialogoSubirImagen}
                        sx={{
                            width: 40,
                            height: 40,
                            backgroundColor: '#EDF0F4',
                            borderRadius: '50%',
                            position: 'absolute',
                            bottom: '-15px',
                            cursor: 'pointer'
                        }}>
                        <PhotoCamera style={IconoCamara.Icon} />
                    </Box>
                </Box>
                <Typography component="div">
                    <Box sx={{ textAlign: 'center', m: 1, maxWidth: '214px' }}>
                        <p>{sesionUsuario.usuario.nombreCompleto}</p>
                    </Box>
                </Typography>
                <Divider />
                <Box display="flex" alignItems="center" justifyContent="center" width={230}>
                    <Button
                        style={styleBotonCerrar.Button}
                        onClick={salirSesionUsuario}
                        size="large"
                        startIcon={<ExitToAppIcon style={styleToolBar.Icon} />}>
                        {etiquetas.EtiquetasComponente.General.Et_tbnCerrarSesion}
                    </Button>
                </Box>
                
            </StyledMenu>
        </React.Fragment>
    );
}

export default PerfilUsuarioModal;